import styled from 'styled-components';

/** Horizontal, scroll-on-overflow tab strip (scrollbar hidden). */
export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export default TabsRow;
